import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';

  @Component({
    selector: 'content-list-division1',
    templateUrl: './a-content-list-division1.component.html',
})
export class AContentListDivision1Component implements OnInit {
    @Input() md: any;
    @Input() eflg: boolean;
    
    dupcheckLists:boolean = false;

    constructor(
        private commonService: CommonService,
    ) { }

    ngOnInit() {
        this.changeLanguage();
    }

    addRow(row:number) : void{
        let sss={
            m_language_id: null,
            title_name: null,
            d_code: "",
        };
        this.md.data.content.splice(row+1, 0, sss); // i番目の次に１レコード追加
        this.changeLanguage();
    }
    delRow(row:number) : void{
        if (this.md.data.content.length==1){
            this.md.data.content=[];
            this.addRow(0);
        }else{
            this.md.data.content.splice(row, 1); // i番目を１レコード削除
        }
        this.changeLanguage();
    }
    upRow(row:number) : void{
        if (row==0){//最初

        }else{
            this.md.data.content.splice(row-1, 2, this.md.data.content[row], this.md.data.content[row-1]);
        }
    }
    downRow(row:number) : void{
        if (row==this.md.data.content.length -1){//最終

        }else{
            this.md.data.content.splice(row, 2, this.md.data.content[row+1], this.md.data.content[row]);
        }
    }
    changeLanguage():void{
        this.dupcheckLists =  this.commonService.checkDupRecords(this.md.data.content,'m_language_id');
    }
    
}


// WEBPACK FOOTER //
// ./src/app/a2123-ydivision1/a-content-list-division1.component.ts